import axios from '../../../../../http.service';

const baseUrl = '/api/v2/release/amendContract';
const pagination = '{"sortOrder":"asc","sortField":"amendmentNumber","page":1,"sizePerPage":20,"searchText":"","flagExportData":false}';

export const getAmendments = async (year, markingTeamId, appointmentType) => {
	const url = `${baseUrl}/${year}/details/${markingTeamId}?appointmentType=${appointmentType}&pagination=${pagination}`;
	const { status, data } = await axios.get(url);
	const amendments = status === 200 ? data.data[0].data : [];
	const { errors = [] } = data;
	return { status, amendments, errors };
};
